import React, {FC, useEffect, useState} from "react";
import InputField from "../input-field";

const TinInput: FC<{ tin: string, onChange: (v: string) => void }> = ({ tin, onChange }) => {
  const [value, setValue] = useState<string>(tin ?? "");

  useEffect(() => {
    setValue(tin);
  }, [tin]);

  return <>
    <InputField
      id="tin"
      label="Taxpayer Identification (TIN)"
      defaultValue={value}
      type="text"
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
    />
    <p>This field is required for independent repair shop VIDA subscriptions.</p>
  </>
}

export default TinInput;
